import styled from 'styled-components';

import { ExternalLink as UIExternalLink } from '@/shared/ui/external-link';

export const Link = styled(UIExternalLink)`
	font-weight: 600;
	color: ${({ theme: { text } }) => `${text.colors.tertiary} !important`};
`;
